export default __webpack_public_path__ + "static/media/Vector1.962b0293.svg";